var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2895 25.948C49.2895 37.358 41.0062 48.0447 29.6895 51.1713C28.9195 51.3813 28.0795 51.3813 27.3095 51.1713C15.9928 48.0447 7.70947 37.358 7.70947 25.948V15.7046C7.70947 13.7913 9.15617 11.6213 10.9528 10.898L23.9495 5.57805C26.8661 4.38805 30.1561 4.38805 33.0728 5.57805L46.0695 10.898C47.8428 11.6213 49.3128 13.7913 49.3128 15.7046L49.2895 25.948Z",
    stroke: "#FEFEFE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.d87772dc39344c56b4adb572f3fc2e85.svg";
export { ForwardRef as ReactComponent };